import { useState } from 'react'
import { Button } from 'reactstrap'
import HomepageCarousel from './HomepageCarousel'
import { HubspotBrochureDownload } from '.'
import Lazyload from 'react-lazy-load'

function RefferVantageFit() {
  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  return (
    <div className="page-affiliate">
      <section className="homepage hero-bg position-relative section-pdn-hero pt-8">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg">
          <div className="col-12 col-md-7">
            <div className="col-12">
              <div className="red-font homelabel text-white">VANTAGE FIT AFFILIATE PROGRAM</div>
              <h1 className="font-weight-semibold hero-heading mt-4 no-br">
                <span style={{ color: '#F15162' }}> Spread </span> the Word <br />
                and <span style={{ color: '#F15162' }}>Earn </span> Rewards
              </h1>
              <p className="hero-para font-weight-semibold no-br">
                Promote Vantage Fit to your readers, viewers, clients or customers <br /> and earn a generous award as a
                token of thanks on every successful conversion.
              </p>
              <div className="pl-0 pr-0 col-12 mtb25 d-md-flex justify-content-md-center d-lg-flex justify-content-lg-start align-items-center">
                <a href="#joinNow" className="vfitcompanycta mr-3 arrowbtn-img">
                  Join Now
                </a>
                <a href="https://res.cloudinary.com/vantagecircle/image/upload/v1719483990/VantageFit/pdf/T_C.pdf">
                  <Button className="ghost-btn-white ghost-btn-red">Read T&C</Button>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-5 ">
            <div className="hero-right-img">
              <picture>
                <source
                  media="(max-width: 768px)"
                  srcSet={`https://res.cloudinary.com/vantagecircle/image/upload/w_500/gatsbycms/uploads/2024/06/Affiliated-marketing-hero.png`}
                />

                <source
                  srcSet={`https://res.cloudinary.com/vantagecircle/image/upload/w_500/gatsbycms/uploads/2024/06/Affiliated-marketing-hero.png`}
                />

                <img
                  className="img-responsive"
                  src={`https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/Affiliated-marketing-hero.png`}
                  alt="image 1"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative home-bg-1 section-pdn-1">
        <div className="container custom_container">
          <h2 className="section-heading text-center mb-5 text-white green-text">How the program works?</h2>
          <div className="col-12 col-md-10 offset-md-1 px-0">
            <div className="row">
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/gift-1.png"
                  />
                  <p className="focusstat-w2">Join as Affiliate partner</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Team up with us as an affiliate partner without any fees. After successful review, an ‘Referral
                    Link’ will be shared with you.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/fi_1827425.png"
                  />
                  <p className="focusstat-w2">Advocate our Platform</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Share the ‘Referral Link’ to promote the Vantage Fit's platform with your preferred network.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/fi_6369557.png"
                  />
                  <p className="focusstat-w2">Earn Referral Bonus</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Get an overview of the amount allocated to, debited, credited and the balance remaining over a
                    period of time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative py-5">
        <div className="container custom_container p0 recog-logos">
          <h2 className="col-12 text-center f-500">Promote a globally trusted brand</h2>
          <div className="d-flex justify-content-center align-items-center m-d-block py-5">
            <div className="d-flex justify-content-center align-items-center px-4 py-2 py-lg-0">
              <img
                decoding="async"
                loading="lazy"
                src="https://res.cloudinary.com/vantagecircle/image/upload/v1743156219/VantageFit/2025/badges-vc.webp"
                alt="G2 award4"
                width={800}
                height={400}
                className="img-responsive"
              />
            </div>
          </div>
        </div>
      </section>
      <section id="joinNow" className="position-relative pl-0 pr-0">
        <div className="">
          <div className="">
            <div className="feat_box sect-white-col-2 shadow active_challenge pt-5 pb-5">
              <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                <div className="col-12 col-md-5">
                  <div className="col-12">
                    <h2 className="font-weight-semibold py-2 section-heading">
                      Why partner with <br /> <span style={{ color: '#F15162' }}>Vantage Fit ?</span>
                    </h2>
                    <div>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">Hassle Free Joining</p>
                        <p
                          className="text-white"
                          style={{
                            fontSize: '14px',
                            lineHeight: '1.4',
                          }}
                        >
                          Just fill out the form and refer Vantage Fit using the unique link shared with you. It costs
                          you nothing and pays off with the first referral conversion.
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">Transparent Tracking</p>
                        <p
                          className="text-white"
                          style={{
                            fontSize: '14px',
                            lineHeight: '1.4',
                          }}
                        >
                          Once you are onboarded, you will have access to your own dashboard where you can track your
                          conversions. The dashboard will be accessible for a year.
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">Earn Extra Earnings</p>
                        <p
                          className="text-white"
                          style={{
                            fontSize: '14px',
                            lineHeight: '1.4',
                          }}
                        >
                          Earn easily while promoting our platform in the flow of your work. No need to put an extra
                          effort.
                        </p>
                      </ul>
                      <ul
                        className="greenTick position-relative"
                        style={{
                          minHeight: '29px',
                          marginTop: '2.5rem',
                          marginBottom: '2.5rem',
                        }}
                      >
                        <p className="text-white">Show your credibility</p>
                        <p
                          className="text-white"
                          style={{
                            fontSize: '14px',
                            lineHeight: '1.4',
                          }}
                        >
                          Let your audience know how they can benefit from using our platform, and we’ll make sure their
                          experience is stunning.
                        </p>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-7 cta-img">
                  <div className="d-flex justify-content-center">
                    <div className="aff-form">
                      <h4 className="text-white mb-5 mx-2">Turn your influence into revenue</h4>
                      <Lazyload>
                        <HubspotBrochureDownload formID="5e5794f5-3932-48bc-8ba6-2fbc064d7daf" />
                      </Lazyload>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="position-relative home-bg-1 section-pdn-1">
        <div className="container custom_container">
          <h2 className="section-heading text-center mb-5 text-white green-text">How the program works?</h2>
          <div className="col-12 col-md-10 offset-md-1 px-0">
            <div className="row">
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/Homepage.png"
                  />
                  <p className="focusstat-w2">You have a entrepreneurial mindset</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Team up with us as an affiliate partner without any fees. After successful review, an ‘Referral
                    Link’ will be shared with you.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/fi_3126647.png"
                  />
                  <p className="focusstat-w2">You have a network of corporate health enthusiasts</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Be the wave of change by advocating the importance of engaging employees with one of the global
                    thought leaders and its expert resources.
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="focus-sect">
                  <img
                    className="focus_img"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/gatsbycms/uploads/2024/06/fi_522510.png"
                  />
                  <p className="focusstat-w2">You prioritise a great work culture</p>
                  <p className="stat-para section-para mb-0 text-white font-weight-light">
                    Encourage the need for a positive work-culture across your network with a platform trusted by 100+
                    clients globally.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative pt-5 home-bg-3 pb-5">
        <div className="container custom_container">
          <h2 className="section-heading text-center mb-3 text-white">Explore Vantage Fit</h2>
          <HomepageCarousel />
        </div>
      </section>
      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12">
            <h2 className="section-heading text-center no-br">
              Recommend Our Platform and <br />
              Start Earning Rewards
            </h2>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href="#joinNow" className="vfitcompanycta arrowbtn-img">
                Join Affiliate Program
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default RefferVantageFit
